// Generated by script, please do not edit this file.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as React from 'react';
import { forwardRef } from 'react';
var Send = function(props, ref) {
    return /*#__PURE__*/ React.createElement("svg", _object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M14.832 1.529a.5.5 0 0 1 .664.54l-.018.078-4 13a.5.5 0 0 1-.727.287l-.071-.05-3.462-2.895-1.864 1.865a.5.5 0 0 1-.846-.266l-.007-.086-.013-3.779L.702 7.401a.5.5 0 0 1-.032-.777l.075-.054.088-.041zm-.603 1.276L2.046 7.156l2.946 2.197 6.716-4.76c.496-.352 1.02.292.7.701l-.054.06-.066.054-6.462 4.614 4.916 4.112 3.486-11.329zM5.49 11.197l.006 1.598.796-.796z"
    }));
};
var ForwardRef = /*#__PURE__*/ forwardRef(Send);
export default ForwardRef;
